import { render } from "./AdminStatsPage.vue?vue&type=template&id=14666ab9"
import script from "./AdminStatsPage.vue?vue&type=script&lang=js"
export * from "./AdminStatsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__